import React from "react";
import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <div className={styles.footer}>
      <h1 style={{ marginTop: "20px" }}>Aniket Yadav.</h1>
      <div className={styles.footerDiv}>
        <div className={styles.left}>
          <h4 style={{marginBottom:"10px"}}>Address</h4>
          <p>Goregaon(West), Mumbai, Maharashtra, India</p>
        </div>
        <div className={styles.right}>
          <h4 style={{marginBottom:"10px"}}>Languages</h4>
          <p>English</p>
          <p>Hindi</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
